import type { FC, MouseEvent, ReactNode } from "react";
import { exploreButtonRecipe } from "./ExploreButton.styled";

/**
 * Shared link component styled as a button for explore mode
 * Used for "See Tickets" links
 * Has smooth chevron slide-in animation on hover
 */

interface ExploreButtonProps {
  href: string;
  $showBorder?: boolean;
  onClick?: (e?: MouseEvent) => void;
  children: ReactNode;
  icon?: ReactNode;
}

export const ExploreButton: FC<ExploreButtonProps> = ({ href, $showBorder = true, onClick, children, icon }) => {
  const className = exploreButtonRecipe({ border: $showBorder ? "visible" : "hidden" });

  // Wrap icon with data attribute for hover animation
  const wrappedIcon = icon && <span data-icon="">{icon}</span>;

  return (
    <a href={href} onClick={onClick} className={className}>
      {children}
      {wrappedIcon}
    </a>
  );
};
